import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Card, Radio} from '@material-ui/core';
import Header from 'Components/common/Header';
import {T} from 'Actions/translate';
import {
    getShipToInfo,
    previewOrder,
    updatePreviewOrder,
    addOrder,
    queryStContact,
} from 'Actions/order';
import BasicButton from 'Components/common/BasicButton';
import ShipToConfirm from 'Components/order/ShipToConfirm';
import BillToConfirm from 'Components/order/BillToConfirm';
import LabelInput from 'Components/common/LabelInput';
import ProductDetails from 'Components/order/ProductDetails';
import util from 'Utils/commonUtil';
import Dialog from 'Components/common/Dialog';
import Anchor from 'Components/common/Anchor';
import {openNotification} from 'Actions/notification';
import Checkbox from '@material-ui/core/Checkbox';
import Input from 'Components/common/Input';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {NO_SUPPLY_CENTER_ID} from 'Utils/constant';
import {openTfsRuleUrl, openTfsChangeRuleUrl} from 'Utils/urlUtil';

class OrderConfirmation extends Component {
    state = {
        poNumber: '',
        note: '',
        poNumberTF: '',
        noteTF: '',
        expectShipDate: util.dateFilter(new Date(), 'yyyy-MM-dd'),
        shipToConsignee: '',
        shipToPhone: '',
        billToConsignee: '',
        billToPhone: '',
        billToEmail: '',
        illegalEmail: true,
        shippmentType: 2,
        confirmDialogOpened: false,
        serachData: '',
        tabList: [
            {index: 0, text: T('supply_center_goods')},
            {index: 1, text: T('TFS_goods')},
        ],
        tabActive: 0,
        selectedValue: 0,
        rowId: '',
        billTofieldChange: false,
        checked: false,
        billToConsigneeSearch: false,
        // 'hasCheckTF': false
    };

    componentDidMount() {
        this.getPreviewOrder();
    }

    getPreviewOrder = () => {
        const {localData} = this.props;
        // let cartIds = [];
        let shipToNumber = util.getShipToNumber(localData);

        // cartIds = localData.skuPrices.map((item) => {
        // 	return item.cartId
        // });

        let previewOrderParams = {};
        if (this.getBatchAddSkuShipTo()) {
            previewOrderParams = {
                // 'cartIds': cartIds,
                orderNumbers: localData.orderNumbers,
                email: this.getBatchAddSkuEmail(),
                supplyCenterId: NO_SUPPLY_CENTER_ID,
                shipToNum: this.getBatchAddSkuShipTo(),
            };
        } else {
            previewOrderParams = {
                // 'cartIds': cartIds,
                orderNumbers: localData.orderNumbers,
                email: localData.customerEmail,
                supplyCenterId: localData.scId
                    ? localData.scId
                    : localData.defaultScId
                    ? localData.defaultScId
                    : NO_SUPPLY_CENTER_ID,
                shipToNum: shipToNumber,
            };
        }
        this.props.updatePreviewOrder({});
        this.props.previewOrder(previewOrderParams);
    };

    getBatchAddSkuEmail = () => {
        let currentBatchAddSkuEmail = '';
        if (
            this.props.location.state &&
            this.props.location.state.bacthAddSkuEmail
        ) {
            currentBatchAddSkuEmail = this.props.location.state
                .bacthAddSkuEmail;
        }
        return currentBatchAddSkuEmail;
    };

    getBatchAddSkuShipTo = () => {
        let currentBatchAddSkuShipTo = '';
        if (
            this.props.location.state &&
            this.props.location.state.batchAddSkuShipTo
        ) {
            currentBatchAddSkuShipTo = this.props.location.state
                .batchAddSkuShipTo;
        }
        return currentBatchAddSkuShipTo;
    };

    handleChange = (name, value, isNotEmail) => {
        const {
            invoiceReceiverTel,
            invoiceReceiverEmail,
            stContactQuery,
        } = this.props;
        const {billToEmail} = this.state;
        let isChange = false;
        if (
            (name === 'billToPhone' && invoiceReceiverTel !== value) ||
            (name === 'billToEmail' && invoiceReceiverEmail !== value)
        ) {
            isChange = true;
        }
        if (name === 'billToEmail' && billToEmail && billToEmail !== value) {
            isChange = true;
            this.setState({
                rowId: undefined,
                billTofieldChange: isChange,
            });
        }
        if (typeof isNotEmail === 'undefined') {
            if (name === 'billToPhone') {
                this.setState({
                    [name]: value,
                    billTofieldChange: isChange,
                });
            } else {
                if (name === 'poNumber') {
                    this.setState({
                        [name]: value,
                        poNumberTF: value,
                    });
                } else if (name === 'note') {
                    this.setState({
                        [name]: value,
                        noteTF: value,
                    });
                } else {
                    this.setState({
                        [name]: value,
                    });
                }
            }
        } else {
            if (name === 'billToPhone') {
                this.setState({
                    [name]: value,
                    illegalEmail: isNotEmail,
                    billTofieldChange: isChange,
                });
            } else {
                this.setState({
                    [name]: value,
                    illegalEmail: isNotEmail,
                });
            }
        }
    };

    submitOrder = () => {
        const {
            shipToConsignee,
            shipToPhone,
            billToConsignee,
            billToPhone,
            billToEmail,
            expectShipDate,
            tabActive,
            checked,
            illegalEmail,
        } = this.state;
        const {tfsProducts, scmProducts, invoiceReceiverEmail} = this.props;

        let body = document.getElementsByTagName('body')[0];
        const today = util.dateFilter(new Date(), 'yyyy-MM-dd');
        if (!shipToConsignee) {
            this.props.openNotification(
                T('pleaseEnter') + T('shipToConsignee'),
                'danger',
            );
        } else if (!shipToPhone) {
            this.props.openNotification(
                T('pleaseEnter') + T('shipToPhone'),
                'danger',
            );
        } else if (!billToConsignee) {
            this.props.openNotification(
                T('pleaseEnter') + T('billToConsignee'),
                'danger',
            );
        } else if (!billToPhone) {
            this.props.openNotification(
                T('pleaseEnter') + T('billToPhone'),
                'danger',
            );
        } else if (!illegalEmail) {
            this.props.openNotification(T('errorEmail'), 'danger');
        } else if (!billToEmail) {
            this.props.openNotification(
                T('pleaseEnter') + T('email'),
                'danger',
            );
        } else if (
            this.state.poNumberTF.length > 25 ||
            this.state.poNumber.length > 25
        ) {
            this.props.openNotification(
                T('notification_purchase_order_no_more_than_25_digits'),
                'danger',
            );
        } else if (
            this.state.noteTF.length > 300 ||
            this.state.note.length > 300
        ) {
            this.props.openNotification(
                T('notification_note_message_is_too_long'),
                'danger',
            );
        } else if (!checked) {
            this.props.openNotification(
                T('notification_please_check_and_confirm_the_terms'),
                'danger',
            );
        } else if (expectShipDate < today) {
            this.props.openNotification(
                T(
                    'notification_expected_delivery_date_is_less_than_the_current_date',
                ),
                'danger',
            );
        } else {
            // if (
            //     tabActive === 0 &&
            //     tfsProducts.length > 0 &&
            //     scmProducts.length > 0
            // ) {
            //     this.getPreviewOrder();
            //     this.setState({
            //         tabActive: 1,
            //         // 'poNumberTF': this.state.poNumberTF || this.state.poNumber,
            //         // 			'noteTF': this.state.noteTF || this.state.note
            //     });
            //     window.scrollTo(
            //         0,
            //         document.getElementById('order-confirma-tab-header') &&
            //             document.getElementById('order-confirma-tab-header')
            //                 .scrollHeight +
            //                 body.clientHeight * 0.3,
            //     );
            // } else {
            //     this.setState({
            //         confirmDialogOpened: true,
            //     });
            // }

            this.setState({
                confirmDialogOpened: true,
            });
        }
    };

    getCurrentSubmitProductsScmList = (
        currentSubmitProductsList,
        isRevenueFlag,
    ) => {
        const {tfsProducts, scmProducts} = this.props;
        let listRevenue = 0;
        scmProducts.length > 0 &&
            scmProducts.map((scItem) => {
                if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
                    let currentPrice =
                        parseFloat(scItem.listPrice) * scItem.quantity;
                    listRevenue += currentPrice;
                } else {
                    currentSubmitProductsList.push(scItem);
                }
            });
        if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
            return listRevenue;
        } else {
            return currentSubmitProductsList;
        }
    };

    getCurrentSubmitProductsTfsList = (
        currentSubmitProductsList,
        isRevenueFlag,
    ) => {
        const {tfsProducts, scmProducts} = this.props;
        let listRevenue = 0;
        tfsProducts.length > 0 &&
            tfsProducts.map((tfsItem) => {
                if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
                    let currentTfsPrice =
                        parseFloat(tfsItem.listPrice) * tfsItem.quantity;
                    listRevenue += currentTfsPrice;
                } else {
                    currentSubmitProductsList.push(tfsItem);
                }
            });
        if (typeof isRevenueFlag !== undefined && isRevenueFlag) {
            return listRevenue;
        } else {
            return currentSubmitProductsList;
        }
    };

    handleChangeRadio = (value) => {
        this.setState({
            shippmentType: value,
        });
    };

    confirmDialog = () => {
        const {
            localData,
            hostInfo,
            orderShipTo,
            tfsProducts,
            scmProducts,
            customerRowId,
            orderNumbers,
            invoiceReceiverEmail,
        } = this.props;
        const {
            billToConsignee,
            billToPhone,
            billToEmail,
            shipToConsignee,
            shipToPhone,
            poNumber,
            expectShipDate,
            note,
            shippmentType,
            poNumberTF,
            noteTF,
            selectedValue,
            rowId,
            billTofieldChange,
        } = this.state;
        let tfsProductList = [];
        let scmProductList = [];
        let shipToNumber = util.getShipToNumber(localData);

        // tfsProductList = tfsProducts && tfsProducts.map((item) => {
        // 	return {'cartId': item.cartId, 'discountPrice': this.getSkuPrice(item.cartId).finalPrice, 'extendedPrice': this.getSkuPrice(item.cartId).extendedPrice , 'listPrice':this.getSkuPrice(item.cartId).listPrice, 'lineNumber': this.getSkuPrice(item.cartId).lineNumber, 'webOnlyFlag': this.getSkuPrice(item.cartId).webOnlyFlag}
        // });
        // scmProductList = scmProducts && scmProducts.map((item) => {
        // 	return {'cartId': item.cartId, 'discountPrice': this.getSkuPrice(item.cartId).finalPrice, 'extendedPrice': this.getSkuPrice(item.cartId).extendedPrice, 'listPrice':this.getSkuPrice(item.cartId).listPrice, 'lineNumber': this.getSkuPrice(item.cartId).lineNumber, 'webOnlyFlag': this.getSkuPrice(item.cartId).webOnlyFlag}
        // });

        let pickUpType = 2;
        let supplyCenterId = localData.scId
            ? localData.scId
            : localData.defaultScId
            ? localData.defaultScId
            : NO_SUPPLY_CENTER_ID;

        this.props
            .addOrder({
                stAlphaName: orderShipTo.stAlphaName,
                displayPrice: selectedValue,
                email: this.getBatchAddSkuEmail()
                    ? this.getBatchAddSkuEmail()
                    : localData.customerEmail,
                hostId: hostInfo ? hostInfo.id : '',
                invoiceReceiver: billToConsignee,
                invoiceReceiverAddress: orderShipTo
                    ? util.formatAddress(
                          orderShipTo.btCity,
                          orderShipTo.btAddress,
                          orderShipTo.btBuilding,
                      )
                    : '',
                invoiceReceiverTel: billToPhone,
                invoiceReceiverEmail: billToEmail,
                invoiceTitle: orderShipTo ? orderShipTo.btInstitution : '',
                receiver: shipToConsignee,
                receiverAddress: orderShipTo
                    ? util.formatAddress(
                          orderShipTo.stCity,
                          orderShipTo.stAddress,
                          orderShipTo.stBuilding,
                      )
                    : '',
                receiverTel: shipToPhone,
                shipToNum: this.getBatchAddSkuShipTo()
                    ? this.getBatchAddSkuShipTo()
                    : shipToNumber,
                shippingType: pickUpType,
                supplyCenterId: supplyCenterId,
                promoCodes: localData.promoCodes,
                rowId: billTofieldChange ? rowId : customerRowId,
                scmOrderDetail: {
                    // 'orderProductDetails': scmProductList,
                    purchaseNo: poNumber,
                    remark: note,
                    salesOrderNumber: orderNumbers.scmOrderNumber,
                    // 'jobNumber': localData.scmJobNumber,
                },
                tfsOrderDetail: {
                    // 'orderProductDetails': tfsProductList,
                    purchaseNo: poNumberTF,
                    remark: noteTF,
                    // 'jobNumber': localData.tfsJobNumber,
                    salesOrderNumber: orderNumbers.tfsOrderNumber,
                },
                priceType: localData.priceType,
            })
            .then((res) => {
                this.setState(
                    {
                        pageLoading: false,
                        confirmDialogOpened: false,
                    },
                    () => this.orderSuccess(res, supplyCenterId),
                );
            })
            .catch(() => {
                this.setState({
                    pageLoading: false,
                    confirmDialogOpened: false,
                });
            });
    };

    getSkuPrice = (cartId) => {
        const {localData} = this.props;
        let skuDetails;

        skuDetails =
            localData.skuPrices &&
            localData.skuPrices.filter((item) => {
                return item.cartId === cartId;
            });

        return skuDetails[0] || '';
    };

    orderSuccess = (res, supplyCenterId) => {
        this.props.history.push('/orderSuccess', {
            bacthAddSkuEmail: this.getBatchAddSkuEmail(),
            batchAddSkuShipTo: this.getBatchAddSkuShipTo(),
            supplyCenterId: supplyCenterId,
        });
    };

    handleSearch = (name, item, serachFlg) => {
        const {
            localData,
            invoiceReceiver,
            billToEmail,
            billToPhone,
        } = this.props;
        let shipToNumber = util.getShipToNumber(localData);

        if (item && !serachFlg) {
            this.props.queryStContact({
                queryKey: item.fullName || item,
                shipToNum: this.getBatchAddSkuShipTo()
                    ? this.getBatchAddSkuShipTo()
                    : shipToNumber,
            });
        }
        if (serachFlg && item.email) {
            const strReg = /^\w+((-\w+)|(\.\w+))*\@{1}\w+\.{1}\w{2,4}(\.{0,1}\w{2}){0,1}/gi;
            const isRegFlag = item.email && item.email.search(strReg);
            let isEmailFlag = true;
            if (isRegFlag === -1) {
                isEmailFlag = false;
            }

            if (isEmailFlag) {
                this.handleChange('billToEmail', item.email, true);
            }
        }

        this.setState({
            [name]: item.fullName || item,
            billToPhone: serachFlg
                ? util.formateContactId(item.phoneNumber)
                : this.state.billToPhone,
            billToEmail: serachFlg
                ? item.email
                : this.props.invoiceReceiverEmail
                ? this.props.invoiceReceiverEmail
                : this.state.billToEmail,
            rowId: item.rowId,
            billTofieldChange:
                invoiceReceiver === item ? this.state.billTofieldChange : true,
            billToConsigneeSearch: serachFlg,
        });
    };

    handleChangeTab = (item) => {
        if (this.state.tabActive === item.index) {
            return;
        }
        this.getPreviewOrder();
        if (item.index === 1) {
            this.setState({
                // 'poNumberTF': this.state.poNumberTF || this.state.poNumber,
                // 'noteTF': this.state.noteTF || this.state.note,
                tabActive: item.index,
            });
        } else {
            this.setState({
                tabActive: item.index,
            });
        }
    };

    tabFilter = () => {
        const {tfsProducts, scmProducts} = this.props;
        let tabList = [];

        if (scmProducts && scmProducts.length > 0) {
            tabList.push({index: 0, text: T('supply_center_goods')});
        }

        if (tfsProducts && tfsProducts.length > 0) {
            tabList.push({index: 1, text: T('TFS_goods')});
        }

        return tabList;
    };

    handleDisplayPrice = (event) => {
        let value = event.target.value ? parseInt(event.target.value) : '';
        this.setState({
            selectedValue: value,
        });
    };

    closeDialog = () => {
        this.setState({
            confirmDialogOpened: false,
        });
    };

    handleChangeCheckbox = (name) => (event) => {
        this.setState({
            [name]: event.target.checked,
        });
    };

    handleRadio = (params) => {
        //  	if (params === 'noteTF'){
        //  		this.setState({
        // 	'noteTF': this.state.note
        // })
        //  	} else if (params === 'poNumber') {
        //  		this.setState({
        // 	'poNumberTF': this.state.poNumber
        // })
        //  	}
        this.setState({
            [params + 'TF']: this.state[params],
        });
    };

    render() {
        const {
            shippmentType,
            confirmDialogOpened,
            billToConsignee,
            billToPhone,
            tabActive,
            note,
            noteTF,
            poNumber,
            poNumberTF,
            expectShipDate,
            selectedValue,
            checked,
            billToEmail,
            email,
            billToConsigneeSearch,
        } = this.state;
        const {
            tfsProducts,
            scmProducts,
            hostInfo,
            orderShipTo,
            receiver,
            receiverTel,
            stContactQuery,
            localData,
            invoiceReceiver,
            invoiceReceiverTel,
            invoiceReceiverEmail,
        } = this.props;
        const tabs = this.tabFilter();

        let isTF = false;
        let products = scmProducts;
        let officialWebProducts = tfsProducts;

        return (
            <div className="order-confirmation">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    increment={0}
                    hasUserCenter={true}
                    hasArrowBackIos={true}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={11}>
                            <span>{T('orderConfirmation')}</span>
                        </Grid>
                    </Grid>
                </Header>

                <Grid
                    id="ST_information"
                    className="ship-to-box-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="ship-to-box" item xs={11}>
                        <ShipToConfirm
                            shipToInfo={orderShipTo}
                            hostInfo={hostInfo}
                            receiver={receiver}
                            receiverTel={receiverTel}
                            handleChange={this.handleChange}
                            handleChangeRadio={this.handleChangeRadio}
                            selectedValue={shippmentType}
                            isProxyProcess={
                                this.getBatchAddSkuShipTo()
                                    ? true
                                    : localData.isProxyProcess
                            }></ShipToConfirm>
                    </Grid>
                </Grid>

                <Grid
                    id="BT_information"
                    className="bill-to-box-container no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="bill-to-box" item xs={11}>
                        <BillToConfirm
                            shipToInfo={orderShipTo}
                            receiver={invoiceReceiver}
                            receiverTel={invoiceReceiverTel}
                            handleChange={this.handleChange}
                            billToConsignee={billToConsignee}
                            billToPhone={billToPhone}
                            invoiceReceiverEmail={invoiceReceiverEmail}
                            billToEmail={billToEmail}
                            stContactList={stContactQuery}
                            handleSearch={this.handleSearch}
                            billToConsigneeSearch={billToConsigneeSearch}
                            isProxyProcess={
                                this.getBatchAddSkuShipTo()
                                    ? true
                                    : localData.isProxyProcess
                            }></BillToConfirm>
                    </Grid>
                </Grid>

                {(products && products.length > 0) ||
                (officialWebProducts && officialWebProducts.length > 0) ? (
                    <div>
                        {/* <div
                            id="order-confirma-tab-header"
                            className="tab-header">
                            {tabs.map((item, index) => {
                                return (
                                    <Anchor
                                        key={item.index}
                                        className={util.getClassName({
                                            'tab-item': true,
                                            active:
                                                item.index === tabActive ||
                                                tabs[0].index === 1,
                                        })}
                                        onClickOfSingleTap={() => {
                                            this.handleChangeTab(item);
                                        }}>
                                        {' '}
                                        {item.text}{' '}
                                    </Anchor>
                                );
                            })}
                        </div> */}

                        {products && products.length > 0 && (
                            <Grid
                                className="product-details-list-container no-margin"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <ProductDetails
                                        productList={products}
                                        skuDetailsList={localData.skuPrices}
                                        isTF={false}
                                    />
                                </Grid>
                            </Grid>
                        )}

                        {officialWebProducts && officialWebProducts.length > 0 && (
                            <Grid
                                className="product-details-list-container no-margin tfs-product-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <ProductDetails
                                        productList={officialWebProducts}
                                        skuDetailsList={localData.skuPrices}
                                        isTF={true}
                                    />
                                </Grid>
                            </Grid>
                        )}

                        <Grid
                            className="po-container no-margin"
                            id="po_input"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid item xs={11}>
                                <Card className="order-card">
                                    {tabActive === 0 ? (
                                        <LabelInput
                                            title={
                                                isTF ? 'poNumberTF' : 'poNumber'
                                            }
                                            defaultValue={
                                                isTF ? poNumberTF : poNumber
                                            }
                                            placeholder={T(
                                                'enter_purchase_number',
                                            )}
                                            inputValid={this.handleChange}
                                            type="text"
                                        />
                                    ) : (
                                        <div>
                                            <Grid
                                                className="purchase-number-label"
                                                item
                                                xs={6}>
                                                <span>{T('poNumberTF')}</span>
                                            </Grid>
                                            <div className="po-radio-label">
                                                <RadioGroup
                                                    onChange={this.handleRadio.bind(
                                                        this,
                                                        'poNumber',
                                                    )}>
                                                    <FormControlLabel
                                                        className="po-radio"
                                                        value="1"
                                                        control={<Radio />}
                                                        label={T(
                                                            'order_same_supply_center',
                                                        )}
                                                    />
                                                </RadioGroup>
                                            </div>
                                            <Grid
                                                className="purchase-number-content"
                                                item
                                                xs={12}>
                                                <Input
                                                    type="text"
                                                    title={'poNumberTF'}
                                                    onChange={this.handleChange}
                                                    value={poNumberTF}
                                                    placeholder={T(
                                                        'enter_purchase_number',
                                                    )}
                                                />
                                            </Grid>
                                        </div>
                                    )}
                                </Card>
                            </Grid>
                        </Grid>

                        {/* {!isTF && localData.isProxyProcess ? (
                            <Grid
                                className="date-container no-margin"
                                id="date_input"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid item xs={11}>
                                    <Card className="order-card">
                                        <LabelInput
                                            title={'expectShipDate'}
                                            type={'date'}
                                            inputValid={this.handleChange}
                                            defaultValue={expectShipDate}
                                        />
                                    </Card>
                                </Grid>
                            </Grid>
                        ) : null} */}

                        <Grid
                            className={
                                !isTF
                                    ? 'note-container no-margin is-not-tfs'
                                    : 'note-container no-margin tfs-order'
                            }
                            id="remark_input"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid item xs={11}>
                                <Card className="order-card">
                                    {tabActive === 0 ? (
                                        <LabelInput
                                            title={isTF ? 'noteTF' : 'note'}
                                            defaultValue={isTF ? noteTF : note}
                                            placeholder={T('enter_note')}
                                            inputValid={this.handleChange}
                                            type="text"
                                        />
                                    ) : (
                                        <div>
                                            <Grid
                                                className="purchase-number-label"
                                                item
                                                xs={6}>
                                                <span>{T('noteTF')}</span>
                                            </Grid>
                                            <div className="note-radio-label">
                                                <RadioGroup
                                                    onChange={this.handleRadio.bind(
                                                        this,
                                                        'note',
                                                    )}>
                                                    <FormControlLabel
                                                        className="note-radio"
                                                        value="1"
                                                        control={<Radio />}
                                                        label={T(
                                                            'order_same_supply_center',
                                                        )}
                                                    />
                                                </RadioGroup>
                                            </div>
                                            <Grid
                                                className="purchase-number-content"
                                                item
                                                xs={12}>
                                                <Input
                                                    type="text"
                                                    title={'noteTF'}
                                                    onChange={this.handleChange}
                                                    value={noteTF}
                                                    placeholder={T(
                                                        'enter_note',
                                                    )}
                                                />
                                            </Grid>
                                        </div>
                                    )}
                                </Card>
                            </Grid>
                        </Grid>

                        {!isTF && localData.isProxyProcess ? (
                            <Grid
                                className="display-price-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="display-price-grid"
                                    item
                                    xs={6}>
                                    <span>{T('confirm_delivery_order')}</span>
                                </Grid>
                                <Grid
                                    className="display-price-radio"
                                    item
                                    xs={5}>
                                    <Radio
                                        checked={selectedValue === 1}
                                        onChange={this.handleDisplayPrice}
                                        value={1}
                                        className={
                                            selectedValue === 1
                                                ? 'radio-button checked'
                                                : 'radio-button'
                                        }
                                    />{' '}
                                    {T('display')}
                                    <Radio
                                        checked={selectedValue === 2}
                                        onChange={this.handleDisplayPrice}
                                        value={2}
                                        className={
                                            selectedValue === 2
                                                ? 'radio-button checked'
                                                : 'radio-button'
                                        }
                                    />{' '}
                                    {T('not_display')}
                                </Grid>
                            </Grid>
                        ) : null}
                        {!isTF ? (
                            <Grid
                                className="eone-display-price-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="display-price-label"
                                    item
                                    xs={6}>
                                    <span>{T('show_eone_set_price')}</span>
                                </Grid>
                                <Grid
                                    className="display-price-value"
                                    item
                                    xs={5}>
                                    {orderShipTo.priceDisplayFlag === 'Y'
                                        ? T('eone_set_show_price')
                                        : T('eone_set_not_show_price')}
                                </Grid>
                            </Grid>
                        ) : null}
                        {/*										                { isTF ? <Grid className='tf-notification no-margin' container spacing={0} justify={'space-evenly'}>
														      		<Grid item xs={12}>
																		<span>别忘了确认官网商品订单内容哦！</span>
													                </Grid>
												                 </Grid> : null }*/}
                    </div>
                ) : null}

                <Grid className="check-content" container spacing={0}>
                    <Checkbox
                        checked={checked}
                        onChange={this.handleChangeCheckbox('checked')}
                        className="checkbox-button"
                    />
                    <Grid item xs={10}>
                        <span className="clause">
                            {T('clause_content_one')}
                            <a href="https://www.thermofisher.com/cn/zh/home/global/terms-and-conditions.html">
                                {T('clause_content_two')}
                            </a>
                        </span>
                        <br />
                        <span className="clause">
                            {T('clause_content_three')}
                        </span>
                    </Grid>
                </Grid>

                <Grid className="bottom-content" container spacing={0}>
                    {/*<Grid item xs={3}/>*/}
                    <Grid className="final-price" item xs={8}>
                        {T('order_total_colon')}{' '}
                        <span className="price-font">
                            <i className="rmb"></i>{' '}
                            <span className="price">
                                {util.toMoney(localData.totalPrice || 0)}
                            </span>
                        </span>
                    </Grid>
                    <Grid item xs={4}>
                        <BasicButton
                            type="primary"
                            onClickOfSingleTap={this.submitOrder}>
                            {/* <span>
                                {tabActive === 0 &&
                                tfsProducts &&
                                tfsProducts.length > 0 &&
                                scmProducts &&
                                scmProducts.length > 0
                                    ? T('order_next_step')
                                    : T('order_submit_order')}
                            </span> */}
                            <span>{T('order_submit_order')}</span>
                        </BasicButton>
                    </Grid>
                </Grid>

                <Dialog
                    options={{bgClickClose: true}}
                    opened={confirmDialogOpened}
                    dialogDidClose={this.closeDialog}>
                    <div className="confirm-popup">
                        <Grid
                            className="confirm-title-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-title-grid" item xs={12}>
                                <span>
                                    {T('order_confirm_information_again')}
                                </span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="comfirm-content-container"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid className="confirm-label-grid">
                                <span>{T('order_invoice_title')}</span>
                            </Grid>
                            <Grid className="confirm-content-grid">
                                <span>
                                    {orderShipTo
                                        ? orderShipTo.btInstitution
                                        : ''}
                                </span>
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid className="important-reminder-area">
                                <Grid className="important-reminder">
                                    {T('order_invoice_important_reminder')}
                                </Grid>
                                <Grid className="important-reminder-text">
                                    {T(
                                        'order_invoice_important_reminder_rule_title_new',
                                    )}
                                    {/* <label>
                                        <a href={openTfsRuleUrl} target="_blank">
                                            {T(
                                                'order_invoice_important_reminder_rule_2',
                                            )}
                                        </a>
                                    </label>
                                    {T('order_invoice_important_reminder_text')} */}
                                </Grid>
                            </Grid>
                            <Grid className="important-teminder-item">
                                <ol>
                                    <li>
                                        {T(
                                            'order_invoice_important_reminder_rule_1_1_new',
                                        )}
                                        <label>
                                            <a
                                                href={openTfsRuleUrl}
                                                target="_blank">
                                                {T(
                                                    'order_invoice_important_reminder_rule_1_2_new',
                                                )}
                                            </a>
                                        </label>
                                        {T(
                                            'order_invoice_important_reminder_rule_1_6_new',
                                        )}
                                        <label className="rule_1_3">
                                            {T(
                                                'order_invoice_important_reminder_rule_1_3_new',
                                            )}
                                        </label>
                                        {T(
                                            'order_invoice_important_reminder_rule_1_4_new',
                                        )}
                                        <label className="rule_1_5">
                                            {T(
                                                'order_invoice_important_reminder_rule_1_5_new',
                                            )}
                                        </label>
                                        {T(
                                            'order_invoice_important_reminder_rule_1_7_new',
                                        )}
                                    </li>
                                    <li>
                                        {T(
                                            'order_invoice_important_reminder_rule_2_1_new',
                                        )}
                                        <label>
                                            <a
                                                href={openTfsChangeRuleUrl}
                                                target="_blank">
                                                {T(
                                                    'order_invoice_important_reminder_rule_2_2_new',
                                                )}
                                            </a>
                                        </label>
                                        {T(
                                            'order_invoice_important_reminder_rule_2_3_new',
                                        )}
                                        <label className="rule_2_4">
                                            {T(
                                                'order_invoice_important_reminder_rule_2_4_new',
                                            )}
                                        </label>
                                        {T(
                                            'order_invoice_important_reminder_rule_2_5_new',
                                        )}
                                    </li>
                                    <li>
                                        {T(
                                            'order_invoice_important_reminder_rule_3_1_new',
                                        )}
                                    </li>
                                </ol>
                            </Grid>
                        </Grid>

                        <Grid
                            className="default-button-container"
                            container
                            spacing={0}>
                            <Grid className="default-button-grid" item xs={12}>
                                <BasicButton
                                    disabled={false}
                                    onClickOfSingleTap={this.confirmDialog}>
                                    <span>
                                        {T('order_complete_confirm_new')}
                                    </span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {order, localData} = state;
    return {
        localData: localData,
        hostInfo: order.previewOrder.host,
        scmProducts: order.previewOrder.scmProducts,
        tfsProducts: order.previewOrder.tfsProducts,
        orderShipTo: order.previewOrder.shipTo,
        receiver: order.previewOrder.receiver,
        receiverTel: order.previewOrder.receiverTel,
        invoiceReceiver: order.previewOrder.invoiceReceiver,
        invoiceReceiverTel: order.previewOrder.invoiceReceiverTel,
        stContactQuery: order.stContactQuery,
        customerRowId: order.previewOrder.rowId,
        orderNumbers: order.previewOrder.orderNumbers,
        invoiceReceiverEmail: order.previewOrder.invoiceReceiverEmail,
    };
};

const mapDispatchToProps = {
    previewOrder,
    updatePreviewOrder,
    getShipToInfo,
    addOrder,
    queryStContact,
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation);
